// extracted by mini-css-extract-plugin
export default {"ratingContainer":"rating-details_ratingContainer__XJsbU","ratingType":"rating-details_ratingType__ONdBw","ratingValue":"rating-details_ratingValue__ElDWe"};